import { Subscription } from "../../utils/types/ecommerceType";
import {
  EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME,
  EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME,
} from "../../utils/constants";

export interface PlanDisplayInfo {
  price: string;
  label: string;
}

export function getPlanDisplayInfo(
  subscription: Subscription | undefined | null
): PlanDisplayInfo {
  // Institutional Plan
  if (
    subscription?.productSubType?.name ===
    EX_INSTITUTE_PLAN_ECOMMERCE_SUBTYPE_NAME
  ) {
    return {
      price: "--",
      label: `${
        subscription?.organization?.name ?? "Institutional Plan"
      } Institutional Plan`,
    };
  }
  // Annual Plan
  if (
    subscription?.productSubType?.name === EX_PREMIUM_ECOMMERCE_SUBTYPE_NAME
  ) {
    return { price: "$99", label: "Annual Plan" };
  }
  // Introductory Plan (free or missing plan)
  return { price: "Free", label: "Introductory Plan" };
}
